const oauth2default = {
    client_id: '',
    redirect_uri: '',
    scope: 'profile',
};

const AccessTokenKey = 'access_token';

export default class {
    _endpoint;
    _options;

    constructor(endpoint, options = {}) {
        this._endpoint = endpoint;
        this._options = options;
    }

    sendMutation(mutationRequest) {
        return this._do(mutationRequest.getQueryString(), mutationRequest.getVariables())
            .then(result => {
                if (result.errors) {
                    mutationRequest.reject(new Error(result.errors));
                } else {
                    mutationRequest.resolve({response: result.data});
                }
            });
    }

    sendQueries(queryRequests) {
        return Promise.all(queryRequests.map(queryRequest => this._do(queryRequest.getQueryString(), queryRequest.getVariables())
            .then(result => {
                if (result.errors) {
                    queryRequest.reject(new Error(result.errors));
                } else {
                    queryRequest.resolve({response: result.data});
                }
            })));
    }

    supports(options) {
        // don't support anything
        return false;
    }

    _do(query, variables, dontRetry) {
        return this._getAccessToken()
            .catch(err => {
                // authentication error
                if (this._options.onautherr) {
                    this._options.onautherr(err);
                }

                return Promise.reject('Authentication error');
            })
            .then(token => new Promise((resolve, reject) => {
                let xhrReq = new XMLHttpRequest();
                xhrReq.open('POST', this._endpoint);
                xhrReq.setRequestHeader('Authorization', 'Bearer ' + token);
                xhrReq.setRequestHeader('Content-Type', 'application/json');

                xhrReq.onreadystatechange = () => {
                    if (xhrReq.readyState === XMLHttpRequest.DONE) {
                        if (xhrReq.status !== 200) {
                            reject(xhrReq.responseText);
                        } else {
                            resolve(JSON.parse(xhrReq.responseText));
                        }
                    }
                };

                xhrReq.send(JSON.stringify({
                    query: query.replace(/\n\s*/, ''),
                    variables: variables,
                }));
            }))
            .catch(err => {
                if (dontRetry || err !== 'Invalid Credentials') {
                    return Promise.reject(err);
                }

                // remove the invalid token from local storage and retry
                localStorage.removeItem(AccessTokenKey);

                return this._do(query, variables, true);
            });
    }

    _getAccessToken() {
        let getFromStorage = () => new Promise((resolve, reject) => {
            let token = localStorage.getItem(AccessTokenKey);
            if (token) {
                return resolve(token);
            } else {
                return reject('could not find access token in local storage');
            }
        });

        return getFromStorage().catch(() => this.login().then(() => getFromStorage()));
    }

    login() {
        // resolve right away if access token is already in local storage
        if (localStorage.getItem(AccessTokenKey)) {
            return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
            let oauth = this._options.oauth2 || oauth2default;
            let w = window.open(
                `https://accounts.google.com/o/oauth2/v2/auth?response_type=token&client_id=${oauth.client_id}&redirect_uri=${oauth.redirect_uri}&scope=${oauth.scope}`,
                '138-scouts-portal-login',
                'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400,height=500'
            );

            let timer = setInterval(() => {
                try {
                    if (w.closed) {
                        clearInterval(timer);
                        reject('login window closed');
                    }
                } catch(e) {
                    console.log('probably cross-origin error:', e);
                }
            }, 1000);

            window.oauthcb = params => {
                window.oauthcb = null;
                clearInterval(timer);

                if (params.error) {
                    return reject(params.error);
                }

                let token = params.access_token;
                if (token) {
                    localStorage.setItem(AccessTokenKey, token);
                    return resolve();
                }

                reject('access token was not returned');
            };
        });
    }
}


/** WEBPACK FOOTER **
 ** ./src/auth-net-layer.js
 **/